module.exports = __webpack_public_path__ + "img/pause.b0be8903.svg";